import { useMediaQuery } from '@mui/material';

export const useIsNarrowView = () => {
  return useMediaQuery('(max-height:35rem)');
};
